import { useState, useCallback } from 'react';

interface FollowRelation {
  followerId: string;
  followingId: string;
}

export function useFollowStore(currentUserId: string) {
  const [follows, setFollows] = useState<FollowRelation[]>([]);

  const isFollowing = useCallback(
    (targetId: string) =>
      follows.some((f) => f.followerId === currentUserId && f.followingId === targetId),
    [follows, currentUserId]
  );

  const toggleFollow = useCallback((targetId: string) => {
    if (targetId === currentUserId) return;
    setFollows((prev) => {
      const exists = prev.some(
        (f) => f.followerId === currentUserId && f.followingId === targetId
      );
      if (exists) {
        return prev.filter(
          (f) => !(f.followerId === currentUserId && f.followingId === targetId)
        );
      }
      return [...prev, { followerId: currentUserId, followingId: targetId }];
    });
  }, [currentUserId]);

  const getFollowerCount = useCallback(
    (userId: string) => follows.filter((f) => f.followingId === userId).length,
    [follows]
  );

  const getFollowingCount = useCallback(
    (userId: string) => follows.filter((f) => f.followerId === userId).length,
    [follows]
  );

  return { isFollowing, toggleFollow, getFollowerCount, getFollowingCount };
}
